import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
          Блокнот на пружине, 48 листов (мелованная обложка), 103&times;140 мм
        </p>
        <p>
          Разлиновка страниц: клетка стандартная (5мм), с полями
        </p>
        <p>
          Обложка: мелованная бумага
        </p>
        <p>
          Переплет: пружина
        </p>
        <p>
          Упаковка: плотный конверт с защитой из картона
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
